// Get Lookbook Order
export const GET_LOOKBOOK_ORDER_REQUEST = 'GET_LOOKBOOK_ORDER_REQUEST';
export const GET_LOOKBOOK_ORDER_DONE = 'GET_LOOKBOOK_ORDER_DONE';
export const GET_LOOKBOOK_ORDER_FAILED = 'GET_LOOKBOOK_ORDER_FAILED';
export const GET_LOOKBOOK_ORDER_RESET = 'GET_LOOKBOOK_ORDER_RESET';
